import { render, staticRenderFns } from "./We.Branches.vue?vue&type=template&id=47842402&"
import script from "./We.Branches.vue?vue&type=script&lang=js&"
export * from "./We.Branches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports